import {
  ApiClient,
  GetBlogOptions,
  GetBlogResponse,
  ListBlogsResponse,
  ListBlogsOptions,
  GetBlogRequest,
  ListBlogsRequest,
  ListAuthorsOptions,
  ListAuthorsResponse,
  ListAuthorsRequest,
  ListTagsResponse,
  ListTagsRequest,
} from "@quotientjs/core"

export class Blog {
  private apiClient: ApiClient

  constructor(apiClient: ApiClient) {
    this.apiClient = apiClient
  }

  /**
   * Retrieves a single blog post by its slug.
   *
   * @param {GetBlogOptions} options - Options for retrieving the blog post
   * @returns {GetBlogResponse} Promise resolving to the blog post data
   */
  async get(options: GetBlogOptions): Promise<GetBlogResponse> {
    const request = new GetBlogRequest(options)
    const response = await this.apiClient.call(request)
    return response
  }

  /**
   * Lists all blog posts with optional filtering and pagination.
   *
   * @param {ListBlogsOptions} options - Options for filtering and paginating the blog posts
   * @returns {ListBlogsResponse} Promise resolving to a list of blog posts
   */
  async list(options: ListBlogsOptions): Promise<ListBlogsResponse> {
    const request = new ListBlogsRequest(options)
    const response = await this.apiClient.call(request)
    return response
  }

  /**
   * Lists all blog authors with optional filtering and pagination.
   *
   * @param {ListAuthorsOptions} options - Options for filtering and paginating the authors
   * @returns {ListAuthorsResponse} Promise resolving to a list of blog authors
   */
  async listAuthors(options: ListAuthorsOptions): Promise<ListAuthorsResponse> {
    const request = new ListAuthorsRequest(options)
    const response = await this.apiClient.call(request)
    return response
  }

  /**
   * Lists all blog tags.
   *
   * @returns {ListTagsResponse} Promise resolving to a list of blog tags
   */
  async listTags(): Promise<ListTagsResponse> {
    const request = new ListTagsRequest()
    const response = await this.apiClient.call(request)
    return response
  }
}
